<template>
    <div class="all-section-area">
        <MainHeader />
        <main class="main-content-wrap">
            <PageTitle mainTitle="Avatar Radius" pageTitle="Avatar Radius" />
            <AvatarRadius />
            <div class="flex-grow-1"></div>
            <FooterArea />
        </main>
    </div>
</template>

<script>
import MainHeader from '../Layouts/MainHeader'
import PageTitle from '../Common/PageTitle'
import AvatarRadius from '../AvatarRadius/AvatarRadius'
import FooterArea from '../Layouts/FooterArea'

export default {
    name: 'AvatarRadiusPage',
    components: {
        MainHeader,
        PageTitle,
        AvatarRadius,
        FooterArea,
    },
    mounted () {
        document.body.classList.add('body-bg-f8faff')
    },
}
</script>